import { render, staticRenderFns } from "./shopping_cart.vue?vue&type=template&id=1736d573&scoped=true"
import script from "./shopping_cart.vue?vue&type=script&lang=js"
export * from "./shopping_cart.vue?vue&type=script&lang=js"
import style0 from "./shopping_cart.vue?vue&type=style&index=0&id=1736d573&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1736d573",
  null
  
)

export default component.exports